// src/contexts/ReferentesContext.jsx
import { createContext, useContext, useCallback, useState } from 'react';

export const ReferentesContext = createContext({
    refetchReferentes: () => { },
    registerRefetch: () => { }
});

export const useReferentes = () => {
    const context = useContext(ReferentesContext);
    if (!context) {
        throw new Error('useReferentes debe usarse dentro de ReferentesProvider');
    }
    return context;
};

export const ReferentesProvider = ({ children }) => {
    const [nuevoReferente, setNuevoReferente] = useState(null); // Estado para el nuevo referente creado

    const [refetchFn, setRefetchFn] = useState(() => () => { });

    const registerRefetch = useCallback((fn) => {
        setRefetchFn(() => fn);
    }, []);

    const value = {
        nuevoReferente,
        setNuevoReferente,
        refetchReferentes: refetchFn,
        registerRefetch
    };

    return (
        <ReferentesContext.Provider value={value}>
            {children}
        </ReferentesContext.Provider>
    );
};